import styled from 'styled-components';
import { black, border1, lightGray } from '../../../../../utils/style/colors';

export const MainTBody = styled.tbody<{ showProgress?: boolean }>`
  ${(props) => {
    return props.showProgress
      ? '& > *:nth-child(even) {\n    border-bottom: 2px solid #777777;\n  }'
      : '& > * {\n    border-bottom: 2px solid #777777;\n  }';
  }}
`;

export const MoreInformationTable = styled.table`
  border-collapse: collapse;
  border-radius: 0.5rem;
  border-spacing: 0;
  overflow: hidden;
`;

export const MoreInformationTR = styled.tr`
  border: ${border1};
  & > th {
    background: ${lightGray};
    color: ${black};
  }

  & > td {
    background: var(--exact-white);
  }
`;
